"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResumesSelectField = ResumesSelectField;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const { Option } = antd_1.Select;
function ResumesSelectField({ addResumeRules, setHasResumesAndWantsToUpload, myResumes }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: "savedResumes", label: intl.formatMessage({
            id: 'offer_detail.send_resume_form.resume',
        }), rules: addResumeRules, children: (0, jsx_runtime_1.jsxs)(antd_1.Select, { onChange: value => setHasResumesAndWantsToUpload(value === 0), children: [(0, jsx_runtime_1.jsx)(Option, { id: 0, value: 0, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.send_new_resume" }) }, 0), myResumes.map(resume => ((0, jsx_runtime_1.jsx)(Option, { id: resume.id, value: resume.id, children: resume.resume_name }, resume.id)))] }) }));
}
